import { useMutation } from '@tanstack/react-query';

import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface DeleteQuestionsVariables {
  questionUid: string;
  competencyUid: string;
}

const useDeleteQuestions = () => {
  const {
    mutateAsync: deleteQuestions,
    data,
    isLoading,
    error,
  } = useMutation<Record<string, never>, Error, DeleteQuestionsVariables>(
    ['deleteQuestions'],
    async ({ competencyUid, questionUid }) => {
      const body = {
        question_uid: questionUid,
        uid: competencyUid,
      };
      return fetchWithCsrfToken('builder/async/questions/delete', 'POST', body);
    }
  );

  return {
    deleteQuestions,
    data,
    isLoading,
    error,
  };
};

export default useDeleteQuestions;
